module.exports = __webpack_public_path__ + "static/media/teilnahme.535f83e5.jpg";